const LINKEDIN_CONVERSION_IDS = {
  ebook_free: 29395441,
  ebook_purchase: 29395449,
  smartbook_purchase: 29395457,
  video_purchase: 29395465,
  bundle_deal: 29395473,
  premium_signup: 29395481,
};

const PREMIUM_FALLBACK_VALUES = { 5: 10, 6: 100 };

// Meta receives these events through GTM, LinkedIn through the Insight Tag.
// Never let a tracking failure break a checkout or signup flow.
export const trackConversion = (event, payload = {}) => {
  try {
    const data = { event, currency: 'CHF', ...payload };

    // Test orders must not reach the ad platforms, they would distort campaign optimization
    if (process.env.REACT_APP_ENV !== 'production') {
      console.warn('conversion (not sent outside production)', data); // eslint-disable-line no-console

      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);

    const conversionId = LINKEDIN_CONVERSION_IDS[event];

    if (conversionId && typeof window.lintrk === 'function') {
      window.lintrk('track', { conversion_id: conversionId });
    }
  } catch (e) {
    // ignore
  }
};

export const trackPremiumSignup = ({ value, productId, currency } = {}) => {
  trackConversion('premium_signup', {
    value: Number.isFinite(value) ? value : PREMIUM_FALLBACK_VALUES[productId] || 100,
    currency: currency || 'CHF',
  });
};

export const trackVideoPurchase = ({ value, currency } = {}) => {
  trackConversion('video_purchase', {
    value: Number.isFinite(value) ? value : 4,
    currency: currency || 'CHF',
  });
};
